export const ACCEPTED_FILE_TYPES = {
  documents: {
    PDF: 'application/pdf',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    DOC: 'application/msword',
    RTF: 'application/rtf',
    RTF_TEXT: 'text/rtf',
    TXT: 'text/plain',
  },
  spreadsheets: {
    XLS: 'application/vnd.ms-excel',
    XLSX: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    CSV: 'text/csv',
  },
  presentations: {
    PPT: 'application/vnd.ms-powerpoint',
    PPTX: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  },
  images: {
    JPEG: 'image/jpeg',
    JPG: 'image/jpg',
    PNG: 'image/png',
    GIF: 'image/gif',
    BMP: 'image/bmp',
    TIFF: 'image/tiff',
  },
  archives: {
    ZIP: 'application/zip',
    // What Windows browsers report for a .zip.
    ZIP_COMPRESSED: 'application/x-zip-compressed',
    TAR: 'application/x-tar',
    GZIP: 'application/gzip',
    GZ_EXT: '.gz',
  },
  video: {
    MP4: 'video/mp4',
  },
  otherExtensions: {
    RTF_EXT: '.rtf',
  },
};

export const FILE_EXTENSION_MAP = {
  documents: {
    [ACCEPTED_FILE_TYPES.documents.PDF]: 'pdf',
    [ACCEPTED_FILE_TYPES.documents.DOCX]: 'docx',
    [ACCEPTED_FILE_TYPES.documents.DOC]: 'doc',
    [ACCEPTED_FILE_TYPES.documents.RTF]: 'rtf',
    [ACCEPTED_FILE_TYPES.documents.RTF_TEXT]: 'rtf',
    [ACCEPTED_FILE_TYPES.documents.TXT]: 'txt',
  },
  spreadsheets: {
    [ACCEPTED_FILE_TYPES.spreadsheets.XLS]: 'xls',
    [ACCEPTED_FILE_TYPES.spreadsheets.XLSX]: 'xlsx',
    [ACCEPTED_FILE_TYPES.spreadsheets.CSV]: 'csv',
  },
  presentations: {
    [ACCEPTED_FILE_TYPES.presentations.PPT]: 'ppt',
    [ACCEPTED_FILE_TYPES.presentations.PPTX]: 'pptx',
  },
  images: {
    [ACCEPTED_FILE_TYPES.images.JPEG]: 'jpg',
    [ACCEPTED_FILE_TYPES.images.JPG]: 'jpg',
    [ACCEPTED_FILE_TYPES.images.PNG]: 'png',
    [ACCEPTED_FILE_TYPES.images.GIF]: 'gif',
    [ACCEPTED_FILE_TYPES.images.BMP]: 'bmp',
    [ACCEPTED_FILE_TYPES.images.TIFF]: 'tiff',
  },
  archives: {
    [ACCEPTED_FILE_TYPES.archives.ZIP]: 'zip',
    [ACCEPTED_FILE_TYPES.archives.ZIP_COMPRESSED]: 'zip',
    [ACCEPTED_FILE_TYPES.archives.TAR]: 'tar',
    [ACCEPTED_FILE_TYPES.archives.GZIP]: 'gz',
  },
};

// File type signatures (magic numbers)
export const FILE_SIGNATURES = {
  documents: {
    PDF: [0x25, 0x50, 0x44, 0x46], // %PDF
    DOCX: [0x50, 0x4b, 0x03, 0x04], // PK
    DOC: [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1], // Compound File Binary Format
    RTF: [0x7b, 0x5c, 0x72, 0x74, 0x66], // {\rtf
    TXT: [0x74, 0x65, 0x78, 0x74], // text
  },
  spreadsheets: {
    XLS: [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1], // Compound File Binary Format
    XLSX: [0x50, 0x4b, 0x03, 0x04], // PK
    CSV: [0x63, 0x73, 0x76], // CSV files typically start with 'csv' in text
  },
  presentations: {
    PPT: [0xd0, 0xcf, 0x11, 0xe0, 0xa1, 0xb1, 0x1a, 0xe1], // Compound File Binary Format
    PPTX: [0x50, 0x4b, 0x03, 0x04], // PK
  },
  images: {
    // FF D8 FF only: the 4th byte varies (E0 JFIF, E1 EXIF phone/camera photos, DB, EE, E2).
    JPEG: [0xff, 0xd8, 0xff],
    JPG: [0xff, 0xd8, 0xff],
    PNG: [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a], // PNG
    GIF: [0x47, 0x49, 0x46, 0x38], // GIF8 — both GIF87a and GIF89a
    BMP: [0x42, 0x4d], // BM
    // Either byte order: II* (little-endian) or MM*.
    TIFF: [
      [0x49, 0x49, 0x2a, 0x00],
      [0x4d, 0x4d, 0x00, 0x2a],
    ],
  },
  archives: {
    ZIP: [0x50, 0x4b, 0x03, 0x04], // PK
    ZIP_COMPRESSED: [0x50, 0x4b, 0x03, 0x04], // PK
    TAR: [0x75, 0x73, 0x74, 0x61, 0x72], // ustar
    GZIP: [0x1f, 0x8b], // GZIP
    GZ_EXT: [0x1f, 0x8b], // GZIP
  },
  otherExtensions: {
    RTF_EXT: [0x7b, 0x5c, 0x72, 0x74, 0x66], // {\rtf
  },
  video: {
    MP4: [0x66, 0x74, 0x79, 0x70, 0x6d, 0x70, 0x34, 0x32], // ftypmp42
  },
};
